module.exports = __webpack_public_path__ + "d02e9bfc32383a2f023b89fd81107fa7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/regeneron_pharmaceuticals_2023_chart.png
// module id = 1718
// module chunks = 0